import axiosClient from "./axiosClient";

export const getBillingPlanList = () => {
  const url = `/billing`;
  return axiosClient.get(url);
};

export const assignBillingPlan = (param) => {
  const url = `/billing`;
  return axiosClient.post(url, param);
};

export const getCompanySubscription = (companyId) => {
  const url = `/billing/company/${companyId}`;
  return axiosClient.get(url);
};
export const getCustomerId = (param) => {
  const url = `/billing/customer/${param}`;
  return axiosClient.get(url);
};

export const getCustomerPortal = (param) => {
  const url = `/billing/customer/${param}/portal`;
  return axiosClient.get(url);
};

export const getCustomerCheckout = (param) => {
  const url = `/billing/customer/${param}/checkout_url`;
  return axiosClient.get(url);
};

export const getPaymentIntent = (param) => {
  const url = `/billing/checkout_url/${param}`;
  return axiosClient.get(url);
};

export const updatePaymentMethod = (params) => {
  const url = `/billing/payment-methods`;
  return axiosClient.post(url, params);
};

export const exportBillingUsage = () => {
  const url = `/billing/export`;
  return axiosClient.get(url, {
    responseType: "blob",
  });
};

export const getPaymentMethods = () => {
  const url = `/billing/payment-methods`;
  return axiosClient.get(url);
};

export const getBillingTransactions = () => {
  const url = `/billing/transactions`;
  return axiosClient.get(url);
};

export const payInvoice = (invoiceId) => {
  const url = `/billing/invoices/${invoiceId}/pay`;
  return axiosClient.post(url);
};

export const getLagoAddOns = () => {
  const url = `/billing/add-ons`;
  return axiosClient.get(url);
};

export const getLagoPlan = (planCode) => {
  const url = `/billing/plans/${planCode}`;
  return axiosClient.get(url);
};

export const generateCompanyInvoices = (companyId) => {
  const url = `/billing/invoices/${companyId}/generate`;
  return axiosClient.post(url);
};

export const getPublicPlans = () => {
  const url = `/billing/public_plans`;
  return axiosClient.get(url);
};

export const cancelSubscription = () => {
  const url = `/billing/subscription`;
  return axiosClient.delete(url);
};
